import {useEffect} from "react";
import {loadSticker} from "../entities/stickers/actions";
import {useDispatch, useSelector} from "react-redux";
import {loadStickerItems} from "../entities/sticker-items/actions";
import {stickerFetchStatusSelector, stickerSelector} from "../entities/stickers/selectors";
import {stickerItemsFetchStatusSelector, stickerItemsSelector} from "../entities/sticker-items/selectors";
import {FetchStatus, ISticker} from "../entities/stickers/reducer";
import {IStickerItem} from "../entities/sticker-items/reducer";


export function useSticker(stickerId: string, options = {scanEvent: false}): [ISticker | null, IStickerItem[] | null] {
    const {scanEvent} = options;
    const dispatch = useDispatch();
    const sticker = useSelector((state) => stickerSelector(state, stickerId))
    const stickerStatus = useSelector((state) => stickerFetchStatusSelector(state, stickerId))
    const stickerItems = useSelector((state) => stickerItemsSelector(state, sticker?.stickerItems || null))
    const stickerItemsStatus = useSelector((state) => stickerItemsFetchStatusSelector(state, stickerId))

    useEffect(() => {
        dispatch(loadSticker(stickerId, {scanEvent}))
    }, [stickerId, scanEvent])

    useEffect(() => {
        dispatch(loadStickerItems(stickerId))
    }, [stickerId, sticker?.configured_date])


    if (["idle"].indexOf(stickerStatus) > 0 || ["idle"].indexOf(stickerItemsStatus) > 0) {
        return [null, null];
    }

    return [sticker, stickerItems || null]
}

export function useSticker2(stickerId: string, options = {scanEvent: false}): [ISticker | null, FetchStatus] {
    const {scanEvent} = options;
    const dispatch = useDispatch();
    const sticker = useSelector((state) => stickerSelector(state, stickerId))
    const stickerStatus = useSelector((state) => stickerFetchStatusSelector(state, stickerId))

    useEffect(() => {
        dispatch(loadSticker(stickerId, {scanEvent}))
    }, [stickerId, scanEvent])


    return [sticker, stickerStatus]
}


export function useStickerItems(stickerId: string, stickerItemId: string): [IStickerItem[] | null, FetchStatus] {
    const dispatch = useDispatch();
    const stickerItems = useSelector((state) => stickerItemsSelector(state, [stickerItemId]))
    const stickerItemsStatus = useSelector((state) => stickerItemsFetchStatusSelector(state, stickerId))

    useEffect(() => {
        dispatch(loadStickerItems(stickerId))
    }, [stickerId, stickerItemId])

    return [stickerItems, stickerItemsStatus]
}

export function useStickerItem(stickerId: string, stickerItemId: string): [IStickerItem | null, FetchStatus] {
    const [stickerItems, stickerItemsStatus] = useStickerItems(stickerId, stickerItemId);
    return [stickerItems?.[0] || null, stickerItemsStatus];
}




// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/sticker-show/hooks.tsx